import { ConsentForm } from "@/models/consents";
import { ApplicantTypeIds } from "@/config/constants";
import store from "@/store";

export default function useConsents() {
  function findConsentByApplicantTypeId(
    state: any,
    consentTypeId: number,
    applicantTypeId: number,
  ): ConsentForm {
    const consents = applicantTypeId
      ? applicantTypeId === ApplicantTypeIds.PRIMARY_APPLICANT
        ? state.primaryApplicantConsents
        : state.coApplicantConsents
      : [];

    return consents?.find((c: ConsentForm) => c.consentTypeId === consentTypeId);
  }

  function consentExists(state: any, consentTypeId: number) {
    const primaryApplicantConsent = findConsentByApplicantTypeId(
      state,
      consentTypeId,
      ApplicantTypeIds.PRIMARY_APPLICANT,
    );

    const coApplicantConsent = findConsentByApplicantTypeId(
      state,
      consentTypeId,
      ApplicantTypeIds.CO_APPLICANT,
    );

    if (primaryApplicantConsent || coApplicantConsent) {
      if (store.state.appData.application.metadata.withCoApplicants) {
        return primaryApplicantConsent?.consentGiven || coApplicantConsent?.consentGiven;
      } else {
        return primaryApplicantConsent?.id && primaryApplicantConsent?.consentGiven;
      }
    } else {
      return false;
    }
  }

  return {
    findConsentByApplicantTypeId,
    consentExists,
  };
}
